// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\(tabs)\\_layout.tsx"); } },
  "./(tabs)/aba/[id].tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\(tabs)\\aba\\[id].tsx"); } },
  "./(tabs)/ajustes.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\(tabs)\\ajustes.tsx"); } },
  "./(tabs)/anotacoes.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\(tabs)\\anotacoes.tsx"); } },
  "./(tabs)/areas.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\(tabs)\\areas.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\(tabs)\\index.tsx"); } },
  "./(tabs)/mensagens.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\(tabs)\\mensagens.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\_layout.tsx"); } },
  "./baixar.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\baixar.tsx"); } },
  "./chamada.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\chamada.tsx"); } },
  "./conversa.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\conversa.tsx"); } },
  "./convite.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\convite.tsx"); } },
  "./excluir-conta.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\excluir-conta.tsx"); } },
  "./privacidade.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\privacidade.tsx"); } },
  "./termos.tsx": { enumerable: true, get() { return require("C:\\MyPlanner\\app\\termos.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;